/**
 * Floating button — scrolls the window to the top when visible.
 */
import { useEffect, useState } from 'react'
import { ChevronUp } from 'lucide-react'
import { cn } from '@/lib/utils'

const SCROLL_THRESHOLD = 320

export function ScrollToTopButton({ stackedAboveFloatingWidget = false }: { stackedAboveFloatingWidget?: boolean }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > SCROLL_THRESHOLD)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      className={cn(
        'fixed right-6 z-30 flex h-11 w-11 items-center justify-center rounded-full',
        stackedAboveFloatingWidget ? 'bottom-24' : 'bottom-6',
        'bg-primary-600 text-white shadow-lg ring-1 ring-black/5',
        'transition-all duration-300 hover:bg-primary-700 hover:shadow-xl',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
        visible
          ? 'translate-y-0 opacity-100 pointer-events-auto'
          : 'translate-y-4 opacity-0 pointer-events-none',
      )}
    >
      <ChevronUp className="h-5 w-5" aria-hidden />
    </button>
  )
}
